// import "./App.css";
// import Certificates from "./components/certificates/Certificates";
import AboutMe from "../sections/aboutMe/AboutMe";
import Contact from "../sections/contact/Contact";
import Experience from "../sections/experience/Experience";
import Footer from "../sections/footer/Footer";
import Header from "../sections/header/Header";
import Hero from "../sections/hero/Hero";
import Projects from "../sections/projects/Projects";

export default function AllSections() {
  return (
    <>
      <Header />
      <Hero />
      <AboutMe />
      <Experience />
      {/* <Certificates /> */}
      <Projects />
      <Contact />
      <Footer />
    </>
  );
}
